<template>
	<section class="faq-list">
		<h2 class="faq-list__title">Часто задаваемые вопросы и готовые ответы</h2>
		<ul class="faq-list__list">
			<li class="faq-list__item" @click="faqBtnHandler($event)">
				<button class="faq-list__label">Как я могу получить доступ к рабочим программам и системам?<span class="faq-list__icon" aria-hidden="true"></span></button>
				<div class="faq-list__content">
					<p>
						Все стандартные доступы вам уже предоставлены. Вы&nbsp;можете войти в&nbsp;системы с&nbsp;помощью логина и&nbsp;пароля,
						который вы&nbsp;получили в&nbsp;приветственном письме. Если возникнут проблемы с&nbsp;доступом,
						обратитесь в&nbsp;<nobr>IT-отдел</nobr> через заявку в
						<a href="https://jirasd.o.kg/servicedesk/customer/portal/1" class="link-btn" target="_blank" rel="noopener noreferrer">Jira</a>.
						<span class="bold-font">Необходимо уточнить у куратора</span>.
					</p>
				</div>
			</li>
			<li class="faq-list__item" @click="faqBtnHandler($event)">
				<button class="faq-list__label">Как проходят перерывы и обеды?<span class="faq-list__icon" aria-hidden="true"></span></button>
				<div class="faq-list__content">
					<p>
						Обеденный перерыв длится с&nbsp;<nobr>13:00&mdash;14:00</nobr>. Перерывы для отдыха можно брать по&nbsp;необходимости, не&nbsp;нарушая текущий рабочий процесс.
					</p>
				</div>
			</li>
			<li class="faq-list__item" @click="faqBtnHandler($event)">
				<button class="faq-list__label">К кому обращаться, если возникают технические проблемы?<span class="faq-list__icon" aria-hidden="true"></span></button>
				<div class="faq-list__content">
					<p>
						Если возникли проблемы с&nbsp;техникой или программным обеспечением, обратитесь в&nbsp;<nobr>IT-отдел</nobr>.
						Для этого необходимо создать заявку в&nbsp;<a href="https://jirasd.o.kg/servicedesk/customer/portal/1" target="_blank" rel="noopener noreferrer">Jira</a>.
					</p>
				</div>
			</li>
			<li class="faq-list__item" @click="faqBtnHandler($event)">
				<button class="faq-list__label">Какой у компании дресс-код?<span class="faq-list__icon" aria-hidden="true"></span></button>
				<div class="faq-list__content">
					<p>
						В&nbsp;нашей компании соблюдается формальный/свободный <nobr>дресс-код</nobr>.
						Важно, чтобы одежда была опрятной и&nbsp;соответствовала рабочему окружению.
					</p>
				</div>
			</li>
			<li class="faq-list__item" @click="faqBtnHandler($event)">
				<button class="faq-list__label">Какие у компании правила по отпуску и больничным?<span class="faq-list__icon" aria-hidden="true"></span></button>
				<div class="faq-list__content">
					<p>
						Мы&nbsp;работаем в&nbsp;соответствии с&nbsp;Трудовым Кодексом КР. Согласно законодательству,
						Ваш отпуск составляет 28 календарных дней. Для планирования отпуска согласуйте даты
						с&nbsp;Вашим руководителем. Полная информация об&nbsp;отпуске
						<a href="https://ecm.o.kg/employeeFaq/get/42" class="link-btn" target="_blank" rel="noopener noreferrer">по&nbsp;ссылке</a>
					</p>
				</div>
			</li>
			<li class="faq-list__item" @click="faqBtnHandler($event)">
				<button class="faq-list__label">Как проходит процесс обучения?<span class="faq-list__icon" aria-hidden="true"></span></button>
				<div class="faq-list__content">
					<p>
						Для каждого нового сотрудника мы&nbsp;проводим вводные тренинги.
						Перед оформлением и&nbsp;приемом на&nbsp;работу вас ждут обучающие сессии по&nbsp;Информационной безопасности,
						Служебной безопасности и&nbsp;Технике безопасности. Если у&nbsp;вас возникнут дополнительные вопросы
						или вам нужна помощь с&nbsp;<nobr>каким-то</nobr> аспектом, всегда можно обсудить это с&nbsp;куратором.
					</p>
				</div>
			</li>
			<li class="faq-list__item" @click="faqBtnHandler($event)">
				<button class="faq-list__label">Какие у нас есть корпоративные мероприятия?<span class="faq-list__icon" aria-hidden="true"></span></button>
				<div class="faq-list__content">
					<p>
						Мы&nbsp;регулярно организуем командные мероприятия, включая тимбилдинги, день рождения компании,
						спортивные активности, субботник, новогодний корпоратив). Вас обязательно пригласят на&nbsp;ближайшее событие,
						это отличный шанс познакомиться с&nbsp;коллегами ближе!
					</p>
				</div>
			</li>
		</ul>
	</section>
</template>

<script>

export default {
	name: 'FAQList',

	props: {
		current_company: ''
	},

	data() {
		return {

		}
	},

	methods: {
		faqBtnHandler(e) {
			const faqList = document.querySelector('.faq-list__list');
			const faqItems = faqList.querySelectorAll('.faq-list__item');

			if (e.currentTarget.classList.contains('is-active')) {
				e.currentTarget.classList.remove('is-active');
			} else {
				faqItems.forEach(item => {
					if (item.classList.contains('is-active')) {
						item.classList.remove('is-active')
					}
				})
				e.currentTarget.classList.add('is-active');
			}
		}
	}
}
</script>

<style>
.faq-list {
	max-width: 760px;
	margin: 0 auto;
}

.faq-list__title {
	margin-bottom: 16px;
	font-size: 22px;
	font-weight: 700;
	line-height: 1.4;
	text-align: center;
}

.faq-list__item.is-active .faq-list__label {
	color: var(--action);
	border-bottom: 1px solid var(--action);
}

.faq-list__item.is-active .faq-list__icon::after {
	width: 0;
}

.faq-list__item.is-active .faq-list__content {
	opacity: 1;
	display: block;
	transition: opacity 200ms linear;
	will-change: opacity;
}

.faq-list__item:not(:last-child) {
	border-bottom: 1px solid var(--border-color);
}

.faq-list__label {
	position: relative;
	width: 100%;
	padding: 16px 0;
	padding-right: 50px;
	border: none;
	font-size: 17px;
	font-weight: 500;
	line-height: 1.4;
	background-color: transparent;
	text-align: left;
}

.faq-list__content {
	padding: 16px 0;
	opacity: 0;
    display: none;
    transition: opacity 200ms linear;
    will-change: opacity;
}

.faq-list__content p {
	line-height: 1.4;
}

.faq-list__icon {
	display: inline-block;
	position: absolute;
	top: 16px;
	right: 0;
	width: 22px;
	height: 22px;
	border: 1px solid;
	border-radius: 22px;

	&::before {
		display: block;
		position: absolute;
		content: '';
		top: 9px;
		left: 5px;
		width: 10px;
		height: 2px;
		background: currentColor;
	}

	&::after {
		display: block;
		position: absolute;
		content: '';
		top: 5px;
		left: 9px;
		width: 2px;
		height: 10px;
		background: currentColor;
	}
}
</style>
